import { API_PUBLIC_HOST, SEARCH_API_HOST } from "@/_constant";
import api from "./request";


export function fetchSearchRecord(payload) {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await api.post(`${SEARCH_API_HOST}/listings/search`,payload);
            resolve(res);
        } catch (err) {
            reject(err);
        }
    })
}

export function fetchSearchFilter(payload) {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await api.post(`${SEARCH_API_HOST}/listings/filter`, payload);
            resolve(res);
        } catch (err) {
            reject(err);
        }
    })
}

export function listUserProfiles(payload) {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await api.post(`${API_PUBLIC_HOST}/userAccessProfile/listUserProfiles`,payload);
            resolve(res);
        } catch (err) {
            reject(err);
        }
    })
}

export function userProfile(userAccessId) {
    return new Promise(async (resolve, reject) => {
        try {
            const res = await api.get(`${API_PUBLIC_HOST}/userAccessProfile/viewUserProfile?userAccessId=`+userAccessId);
            resolve(res);
        } catch (err) {
            reject(err);
        }
    })
}

